import React from "react";
import { BrowserRouter } from "react-router-dom";

const NavigationProvider = ({ children }: React.PropsWithChildren<{}>) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};

export default NavigationProvider;
